import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Typography, Box, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import services from "../data/services.json";
import HeaderImage from "../components/HeaderImage";

type FAQ = {
    question: string;
    answer: string | string[];
};

type Service = {
    id: string;
    name: string;
    image: string;
    description: string;
    faq: FAQ[];
};

function Services() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.replace("#", ""));
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location]);

    return (
        <Box>
            <HeaderImage />

            <Container>
                {services.map((service: Service, index: number) => (
                    <Box id={service.id} key={index} sx={{ mb: 6 }}>
                        <Box
                            component="img"
                            src={service.image}
                            alt={service.name}
                            sx={{
                                display: "block",
                                margin: "0 auto",
                                width: "100%",
                                maxWidth: 870,
                                height: 400,
                                objectFit: "cover",
                                borderRadius: 2,
                                boxShadow:
                                    "0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)",
                            }}
                        />
                        <Typography variant="h4" sx={{ mt: 3, mb: 1, textAlign: "center" }}>
                            {service.name}
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify", mb: 3 }}>
                            {service.description}
                        </Typography>
                        <Typography variant="h5" sx={{ textAlign: "left", mb: 2 }}>
                            Najczęściej zadawane pytania
                        </Typography>

                        {service.faq.map((item, i) => (
                            <Accordion key={i}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>{item.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ textAlign: "justify", mb: 3 }}>
                                    {Array.isArray(item.answer) ? (
                                        <ul style={{ paddingLeft: '40px', margin: 0 }}>
                                            {item.answer.map((ans, idx) => (
                                                <li key={idx}>
                                                    <Typography>{ans}</Typography>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <Typography>
                                            {item.answer}
                                        </Typography>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                ))}
            </Container>
        </Box>
    );
}

export default Services;
